<template>
  <v-menu
    v-model="isOpen"
    :close-on-content-click="false"
    offset-y
    max-width="300px"
  >
    <template v-slot:activator="{ on, attrs }">
      <span v-on="on" v-bind="attrs" class="primaryLight--text">
        <slot></slot>
        <v-icon
          color="primaryLight"
          :class="['animatate', isOpen ? 'rotate' : '']"
          >arrow_drop_down</v-icon
        >
      </span>
    </template>
    <v-card class="pa-2">
      <div
        v-for="(item, i) in _options"
        :key="item.title + i"
        @click="handleSelectClick(item)"
        v-ripple
        :class="['pa-1 pl-3 pr-3 pointer', isSelected(item) ? colorText : '']"
      >
        <span>
          {{ item.title }}
        </span>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "GraphSelect",
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    isOpen: false,
    selection: {},
  }),
  watch: {
    options: {
      immediate: true,
      handler() {
        if (this.options.length) {
          this.handleSelectClick(this.options[0])
        }
      },
    },
  },
  computed: {
    color: () => "primaryLight",
    colorText: () => "primaryLight--text",
    _options() {
      if (this.options.length) {
        return this.options;
      }
      return [];
    },
  },
  methods: {
    isSelected(item) {
      return Object.keys(item).every(
        (key) => item[key] === this.selection[key]
      );
    },
    handleSelectClick(item) {
      this.selection = item;
      this.$emit("input", item);
      setTimeout(() => (this.isOpen = false), 50);
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.animatate {
  transition: all;
  transition-duration: 300ms;
}
.rotate {
  transform: rotate(180deg);
}
</style>